import { render, staticRenderFns } from "./detailHeader.vue?vue&type=template&id=5b7e4ada&scoped=true"
import script from "./detailHeader.vue?vue&type=script&lang=js"
export * from "./detailHeader.vue?vue&type=script&lang=js"
import style0 from "./detailHeader.vue?vue&type=style&index=0&id=5b7e4ada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e4ada",
  null
  
)

export default component.exports